module.exports = __webpack_public_path__ + "img/partner-4_2x.a6c91ac1.png";